import { render, staticRenderFns } from "./ExpInfo.vue?vue&type=template&id=fef9cdca&scoped=true&"
import script from "./ExpInfo.vue?vue&type=script&lang=js&"
export * from "./ExpInfo.vue?vue&type=script&lang=js&"
import style0 from "./ExpInfo.vue?vue&type=style&index=0&id=fef9cdca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fef9cdca",
  null
  
)

export default component.exports